import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, computed, toRefs, reactive, ref, watch } from "vue";
import { Loading } from "@element-plus/icons";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "HelpInPairs",
  components: {
    Head: Head,
    Pagination: Pagination,
    Loading: Loading
  },
  setup: function setup() {
    // 是否禁用筛选
    var disableFleg = computed(function () {
      if (switchIdentity.currentTabIndex1 == 0) {
        return true;
      } else {
        if (dataList.identity != 3) {
          return true;
        } else {
          return false;
        }
      }
    });
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 图片路径前缀


    var baseUrl = process.env.VUE_APP_BASE_URL; //是否可以进行筛选

    var flag = ref(false);
    var loading = ref(false);
    var dataList = reactive({
      listData: [{
        userIcon: "",
        userName: "",
        objectId: null,
        helpState: null,
        personFlag: null,
        phone: null,
        address: "",
        content: ""
      }],
      totalNum: 0,
      identity: 0
    });
    var PaginationInit = ref(false); // 切换变化的值

    var switchIdentity = reactive({
      currentTabIndex1: 0,
      currentTabIndex2: 0,
      selectValue: 0
    }); // 分类相关变量

    var classification = reactive({
      firstTabs: [{
        name: "全部",
        value: 1
      }, {
        name: "待解决",
        value: 4
      }, {
        name: "历史记录"
      }],
      secondTabs: [[{
        name: "全部",
        value: [1]
      }, {
        name: "待帮扶",
        value: [3]
      }, {
        name: "已结束",
        value: [2]
      }], [], [{
        name: "已解决",
        value: [5, 1]
      }, {
        name: "未解决",
        value: [6, 2]
      }, {
        name: "超时",
        value: [7, 3]
      }]],
      // 筛选分类
      options: [{
        typeName: "帮扶",
        value: 0
      }, {
        typeName: "被帮扶",
        value: 1
      }]
    });
    var apiName = ["getHelpInPairsList", "getbeHelpList"]; // 搜索对象参数

    var searchValue = reactive({
      pageIndex: 1,
      pageSize: 3,
      type: 1,
      userName: ""
    }); // // 监听tabs索引值改变

    watch(switchIdentity, function () {
      getTabledata();
    }); // 搜索

    function searchByName() {
      return _searchByName.apply(this, arguments);
    }

    function _searchByName() {
      _searchByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataList.listData = [];
                getTabledata();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _searchByName.apply(this, arguments);
    }

    init(); // 初始化

    function init() {
      getIdentity();
      getTabledata();
    } // 获取数据


    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    }

    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = false;
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[apiName[switchIdentity.selectValue]](searchValue);

              case 3:
                res = _context2.sent;

                if (res.code == 0) {
                  dataList.listData = res.data;
                  dataList.totalNum = res.total;
                  loading.value = true;
                  PaginationInit.value = true;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function getSelectValue(index) {
      console.log('分类', index);
      switchIdentity.selectValue = index;

      if (switchIdentity.currentTabIndex1 == 1) {
        if (index == 0) {
          searchValue.type = 4;
        } else {
          searchValue.type = 0;
        }
      } else {
        searchValue.type = classification.secondTabs[2][switchIdentity.currentTabIndex2].value[index];
      }
    } // 获取用户身份


    function getIdentity() {
      return _getIdentity.apply(this, arguments);
    } // 第一个切换选项卡


    function _getIdentity() {
      _getIdentity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPersonIdentity"]();

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  dataList.identity = res.data;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getIdentity.apply(this, arguments);
    }

    function firstSwitchTab(index) {
      flag.value = false;
      PaginationInit.value = false;

      if (switchIdentity.currentTabIndex1 != index) {
        switchIdentity.currentTabIndex2 = 0;
        switchIdentity.currentTabIndex1 = index;

        if (index == 0) {
          switchIdentity.selectValue = 0;
        }

        if (index == 1) {
          searchValue.type = switchIdentity.selectValue == 1 ? 0 : 4;

          if (dataList.identity == 1) {
            switchIdentity.selectValue = 1;
          }
        } else {
          searchValue.type = classification.secondTabs[index][switchIdentity.currentTabIndex2].value[switchIdentity.selectValue];
        }

        searchValue.pageIndex = 1;
        dataList.listData = [];
      }
    } // 第二个切换选项卡


    function secondSwitchTab(index) {
      PaginationInit.value = false;

      if (switchIdentity.currentTabIndex2 != index) {
        switchIdentity.currentTabIndex2 = index;
        searchValue.type = classification.secondTabs[switchIdentity.currentTabIndex1][index].value[switchIdentity.selectValue];
        searchValue.pageIndex = 1;
        dataList.listData = [];
      }
    } // 筛选分类选择


    function selectChange() {
      if (!disableFleg.value) {
        flag.value = !flag.value;
      }
    } // 跳转详情页


    function godetail(objectId) {
      router.push({
        path: "/personal/helpDetail",
        query: {
          objectId: objectId
        }
      });
    } // 翻页


    function changPage(val) {
      searchValue.pageIndex = val;
      dataList.listData = [];
      getTabledata();
    }

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      baseUrl: baseUrl,
      flag: flag,
      loading: loading,
      PaginationInit: PaginationInit
    }, toRefs(switchIdentity)), toRefs(dataList)), toRefs(searchValue)), toRefs(classification)), {}, {
      disableFleg: disableFleg,
      searchByName: searchByName,
      selectChange: selectChange,
      firstSwitchTab: firstSwitchTab,
      secondSwitchTab: secondSwitchTab,
      getSelectValue: getSelectValue,
      godetail: godetail,
      changPage: changPage
    });
  }
});